import React from 'react';
import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles';

import { colors } from '../../../themes/colors';
import { TestID } from './constants';

type Props = WithStyles<typeof styles> & {
  message?: string;
};

const ErrorMessage: React.FC<Props> = ({ classes, message }) => (
  <div className={classes.message} data-testid={TestID}>
    {message}
  </div>
);

const styles = () =>
  createStyles({
    message: {
      color: colors.red6,
      fontSize: 13,
      lineHeight: '14px',
      marginTop: 10,
    },
  });

export default withStyles(styles)(ErrorMessage);
